import React, { useState } from "react";

import { Box, Modal, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import { StyledButton } from "../Button/StyledButton";
import { CircularProgressCenter } from "../Loading/CircularProgressCenter";

interface TermsModalProps {
  /**
   * Is the drawer open
   */
  open: boolean;

  termsLink?: string;

  /**
   * Callback when the drawer is closed
   */
  onClose?: () => void;

  rejectLink?: string;

  onAccept: () => void;

  onReject?: () => void;

  type: "restaurant" | "user";
}

// Pages specifically used for modal display
const restaurantTnCs = "/restaurant-terms.html";
export const userTnCs = "https://ingredifind.com/user-terms-page";

/**
 * Primary UI component for user interaction
 */
export const TermsModal = ({
  open,
  onAccept,
  onReject,
  termsLink,
  rejectLink,
  onClose,
  type,
}: TermsModalProps) => {
  const [isIFrameLoaded, setIsIFrameLoaded] = useState<boolean>(false);

  const onAcceptClick = () => {
    onAccept();
    onClose && onClose();
  };

  const onRejectClick = () => {
    rejectLink && window.location.replace(rejectLink);
    onReject && onReject();

    // Todo use reject link or ingredifind.com
    onClose && onClose();
  };

  const getTermsByType = (termsType?: string) => {
    switch (termsType) {
      case "restaurant":
        return restaurantTnCs;
      case "user":
        return userTnCs;
      default:
        return "";
    }
  };

  const link = termsLink ? termsLink : getTermsByType(type);

  return (
    <Modal open={open} onClose={(_) => onClose && onClose()}>
      <ModalContainer>
        <Stack gap={1} sx={{ padding: "48px 48px", height: "100%" }}>
          <Typography variant={"headingLLight"}>
            Terms and Conditions
          </Typography>
          {!isIFrameLoaded && <CircularProgressCenter />}
          <iframe
            onLoad={() => setIsIFrameLoaded(true)}
            src={link}
            style={{
              minHeight: 250,
              height: "100%",
              border: "none",
            }}
            hidden={!isIFrameLoaded}
          />
        </Stack>
        <ModalBottomContainer>
          <StyledButton
            label={"I don't agree"}
            size={"large"}
            isGreyStyle
            isOscarDesign
            variant={"contained"}
            onClick={onRejectClick}
            disabled={!isIFrameLoaded}
          />
          <StyledButton
            label={"I agree"}
            size={"large"}
            isOscarDesign
            variant={"contained"}
            onClick={onAcceptClick}
            disabled={!isIFrameLoaded}
          />
        </ModalBottomContainer>
      </ModalContainer>
    </Modal>
  );
};

const ModalContainer = styled(Box)(({ theme }) => ({
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "75vw",
  maxWidth: "936px",
  height: "75vh",
  minWidth: "350px",
  minHeight: "570px",
  backgroundColor: theme.palette.grey[50],
  borderRadius: 24,
  p: 0,
}));

const ModalBottomContainer = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  position: "fixed",
  bottom: 0,
  width: "100%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  gap: 16,
  borderRadius: 24,
  padding: "24px 5%",
  background: `linear-gradient(rgb(255, 255, 255, 0.9), ${theme.palette.grey[50]})`,
}));
